module.exports = __webpack_public_path__ + "img/mini 1.fdc98682.png";